import { Button, Typography, Flex, notification, Card, theme, Checkbox } from "antd"
import { FilePdfFilled, DatabaseOutlined, FileExcelOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useRef, useState } from "react"
import ECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import API from "../../API"
import {ThreeDot} from "react-loading-indicators";
import { runCMJ } from "../../Paginas/Prueba/CMJ/Guardar/cmj";
import { runNordic } from "../../Paginas/Prueba/Nordic/Guardar/nordic";
import { runDynamo } from "../../Paginas/Prueba/Dynamo/Guardar/dynamo";
import { copHistorialDePrueba, runCOP } from "../../Paginas/Prueba/COP/Guardar/cop";
import { GraficaCOP } from "./GraficaCOP";
import dayjs from "dayjs";
import SeleccionarMuestra from "../SeleccionarMuestra";
import { usePruebaContext } from "../../Hooks/Prueba/usepruebacontext";
import { TableParamsPrueba } from "./TableParamsPrueba";
import {
    capturarGraficaPdfExport,
    capturarInstanciaEcharts,
    capturarOpcionEcharts,
    descargarResumenPdf,
    parametrosATablaFilas,
} from "../../Util/resumenPdfPrueba";
import { dataZoomARangoSlice, elegirOpcionDataZoom } from "../../Util/dataZoomMuestras";
import { blobCsvDatosEsp32 } from "../../Util/csvDatosEsp32";
import { blobCsvParametros } from "../../Util/csvParametros";
import { useNavigate } from "react-router-dom";

function categoriasYValores(yArr, xArr, tiempoDecimals = 2) {
    if (!Array.isArray(yArr) || !Array.isArray(xArr)) return { categories: [], values: [] };
    const n = Math.min(yArr.length, xArr.length);
    const categories = [];
    const values = [];
    for (let i = 0; i < n; i++) {
        categories.push(Number(xArr[i]).toFixed(tiempoDecimals));
        values.push(yArr[i]);
    }
    return { categories, values };
}

/** Mismas etiquetas de tiempo que la serie de desplazamiento (mismo índice). */
function velocidadAlineadaADesplazamiento(velY, refDesplazamiento) {
    const { categories } = refDesplazamiento;
    if (!categories.length || !Array.isArray(velY)) return { categories: [], values: [] };
    const n = Math.min(categories.length, velY.length);
    return {
        categories: categories.slice(0, n),
        values: velY.slice(0, n),
    };
}

export const GraficaPrueba = ({}) =>{
    const grafica = useRef(null)
    const navigate = useNavigate();
  
    const [color_area, setColorArea] = useState('whitesmoke')
    const [recalculando, setreCalculando] = useState(false)
    const [newfases, setFases] = useState([])
    const [datosGraficar, setDatosGraficar] = useState([])
    const [inicioFases, setInicioFases] = useState(0)
    const [finFases, setFinFases] = useState(0)
    const [graft , setGraft] = useState({})
    const [newparametros, setParametros] = useState([])
    const [muestra_seleccionada, setMuestraSeleccionada] = useState(null)
    const [verVelocidadDesplazamiento, setVerVelocidadDesplazamiento] = useState(false)
    const {pruebas, pruebaActiva, repIndex, atletas, cargando, setCargando, id} = usePruebaContext()
    const prueba = pruebaActiva ?? pruebas[0]
    const pruebaCompleta = pruebas[0]

    /** Historial COP guardado (`prueba.datos`); también detecta pruebas COP antiguas. */
    const copHistorial = useMemo(() => copHistorialDePrueba(prueba), [prueba]);
    const esCOP = prueba?.tipoPrueba === "COP" || copHistorial.length > 0;

    useEffect(() => {
        setFases([]);
        setParametros([]);
        setDatosGraficar([]);
        setInicioFases(0);
        setFinFases(0);
        setVerVelocidadDesplazamiento(false);
    }, [id, repIndex]);

    /** Fases recalculadas en cliente tienen prioridad; si no, las guardadas en la prueba. */
    const fasesParaMarca =
        Array.isArray(newfases) && newfases.length > 0 ? newfases : prueba?.fases ?? [];
    /** Índices de fases: recalculadas van respecto al zoom (inicioFases); guardadas respecto a inicioFases persistido. */
    const offsetMarcasFases =
        Array.isArray(newfases) && newfases.length > 0 ? inicioFases : prueba?.inicioFases ?? 0;

    const nMuestras = prueba?.sistema_de_pesos_y_tiempos?.length ?? 0;
    const markAreaFases = !nMuestras
        ? []
        : fasesParaMarca
              .filter((f) => f && typeof f.inicio === "number" && typeof f.fin === "number")
              .map((f, i) => {
                  let lo = Math.round(f.inicio + offsetMarcasFases);
                  let hi = Math.round(f.fin + offsetMarcasFases);
                  const maxI = nMuestras - 1;
                  lo = Math.max(0, Math.min(maxI, lo));
                  hi = Math.max(0, Math.min(maxI, hi));
                  if (lo > hi) [lo, hi] = [hi, lo];
                  const labelStagger = (i % 4) * 10 - 15;
                  return [
                      {
                          name: f.nombre,
                          xAxis: lo,
                          itemStyle: { color: f.color, opacity: 0.5 },
                          label: {
                              show: true,
                              color: color_area,
                              position: "insideTop",
                              rotate: 0,
                              fontSize: 10,
                              fontWeight: 600,
                              offset: [0, labelStagger],
                          },
                      },
                      { xAxis: hi },
                  ];
              });

    const graficasCmjVelDesp = useMemo(() => {
        const p0 = prueba;
        if (!p0) return null;
        const esCmj = p0.tipoPrueba === "CMJ" || p0.impresion === "CMJ";
        if (!esCmj) return null;

        const d0 =
            (Array.isArray(datosGraficar) && datosGraficar[0]) || p0.datos?.[0] || null;

        const baseGrid = { left: 58, right: 22, top: 36, bottom: 56 };
        const baseDataZoom = [{ type: "inside" }, { type: "slider", height: 20, bottom: 6 }];

        const disp = d0
            ? categoriasYValores(d0.desplazamiento?.[0], d0.desplazamiento?.[1])
            : { categories: [], values: [] };
        const v = d0 ? velocidadAlineadaADesplazamiento(d0.velocidad?.[0], disp) : { categories: [], values: [] };

        const opcVel =
            v.categories.length > 0
                ? {
                      tooltip: { trigger: "axis" },
                      grid: baseGrid,
                      dataZoom: baseDataZoom,
                      xAxis: {
                          type: "category",
                          name: "Tiempo (s)",
                          nameLocation: "middle",
                          nameGap: 38,
                          data: v.categories,
                      },
                      yAxis: { type: "value", name: "Velocidad (m/s)", nameLocation: "middle", nameGap: 46 },
                      series: [{ name: "Velocidad", type: "line", symbol: "none", smooth: true, data: v.values }],
                  }
                : null;

        const opcD =
            disp.categories.length > 0
                ? {
                      tooltip: { trigger: "axis" },
                      grid: baseGrid,
                      dataZoom: baseDataZoom,
                      xAxis: {
                          type: "category",
                          name: "Tiempo (s)",
                          nameLocation: "middle",
                          nameGap: 38,
                          data: disp.categories,
                      },
                      yAxis: {
                          type: "value",
                          name: "Desplazamiento (m)",
                          nameLocation: "middle",
                          nameGap: 50,
                      },
                      series: [
                          {
                              name: "Desplazamiento",
                              type: "line",
                              symbol: "none",
                              smooth: true,
                              data: disp.values,
                          },
                      ],
                  }
                : null;

        return { opcVel, opcD, faltaDerivados: !opcVel && !opcD };
    }, [pruebas, datosGraficar]);

    const opciones_grafica = {
        type: 'line',
        legend: {

        },
        tooltip: {
            trigger: 'none',
            axisPointer: {
                type: 'cross'
            }
        },
        xAxis: {
            type: 'category',
            name: 'Tiempo (s)',
            nameLocation: 'middle',
            axisLabel: {
                formatter: '{value}',
                align: 'center',
                textStyle: { color: () => color_area },
            },
            nameGap: 40,
            data: prueba?.sistema_de_pesos_y_tiempos?.map(s => s.tiempo.toFixed(1)),
        },
        yAxis: {
            type: 'value',
            name: 'Fuerza (N)',
            boundaryGap: [0, '30%'],
            nameLocation: 'middle',
            nameGap: 50,
            axisLabel: {
                textStyle: { color: () => color_area },
            },
        },
        dataZoom: [
            {
            //    startValue: (doc.inicioFases? doc.inicioFases : 0), realtime: true,
            //    endValue: (doc.finFases? doc.finFases: 700), realtime: true,
            },
            {
                type: 'inside'
            }
        ],
        series: [
            {
                name: 'Píe izquierdo',
                type: 'line',
                symbol: 'none',
                data: prueba?.sistema_de_pesos_y_tiempos?.map(s => s.peso.izq),
                emphasis: {
                    focus: 'series'
                },
            },
            {
                name: 'Píe derecho',
                type: 'line',
                symbol: 'none',
                data: prueba?.sistema_de_pesos_y_tiempos?.map(s => s.peso.der)
                , emphasis: {
                    focus: 'series'
                },
            },
            {
                name: 'Combinado',
                type: 'line',
                backgroundColor: '#F39C12',
                smooth: true,
                data: prueba?.sistema_de_pesos_y_tiempos?.map(d => d.peso.combinada),
                emphasis: {
                    focus: 'series'
                },
                
                markArea: {
                    itemStyle: { opacity: 0.5 },
                    label: { show: false },
                    data: markAreaFases,
                },
            }
        ]
    }
    const opciones_graficaDynamo = {
        type: 'line',
        legend: {},
        tooltip: {
            trigger: 'none',
            axisPointer: {
                type: 'cross'
            }
        },
        xAxis: {
            type: 'category',
            name: 'Tiempo (s)',
            nameLocation: 'middle',
            axisLabel: {
                formatter: '{value}',
                align: 'center'
            },
            nameGap: 40,
            data: prueba?.sistema_de_pesos_y_tiempos.map(s => s.tiempo.toFixed(1)),
        },
        yAxis: {
            type: 'value',
            name: 'Fuerza (N)',
            boundaryGap: [0, '30%'],
            nameLocation: 'middle',
            nameGap: 50
        },
        dataZoom: [
            {
                // Puedes activar estos si tienes valores iniciales de fases
                // startValue: (doc.inicioFases ? doc.inicioFases : 0),
                // endValue: (doc.finFases ? doc.finFases : 700),
                realtime: true
            },
            {
                type: 'inside'
            }
        ],
        series: [
            {
                name: 'Valor',
                type: 'line',
                backgroundColor: '#F39C12',
                data: prueba?.sistema_de_pesos_y_tiempos.map(d => d.peso.combinada),
                markArea: {
                    itemStyle: { opacity: 0.5 },
                    label: { show: false },
                    data: markAreaFases,
                },
            }
        ]
    }
    const generarGrafica = async (xData, yData, text) => {
            return await new Promise((resolve) => {
                // Crear un contenedor temporal para la gráfica
                const chartContainer = document.createElement('div');
                chartContainer.style.width = '800px';
                chartContainer.style.height = '600px';
                document.body.appendChild(chartContainer);
        
                // Inicializar la instancia de ECharts con el tema 'dark2'
                const chart = echarts.init(chartContainer, 'dark2');
        
                // Configuración de la gráfica
                const opciones_grafica = {
                    title: {
                        left: 'center',
                        text: '{title} vs Tiempo(s)'.replace('{title}', text),
                      },
                    tooltip: {
                        trigger: 'axis', // Mostrar información al pasar el mouse
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    xAxis: {
                        type: 'category', // Tipo categoría para el eje x
                        name: 'Tiempo (s)',
                        nameLocation: 'middle',
                        nameGap: 40,
                        axisLabel: {
                            color: 'whitesmoke',
                        },
                        data: xData.map(x => x.toFixed(2)), // Convertir xData a strings con 2 decimales
                    },
                    yAxis: {
                        type: 'value', // Tipo valor para el eje y
                        name: text,
                        nameLocation: 'middle',
                        nameGap: 50,
                        axisLabel: {
                            color: 'whitesmoke',
                        },
                    },
                    series: [
                        {
                            name: 'Fuerza vs Tiempo',
                            type: 'line',
                            smooth: true,
                            symbol: 'circle', // Mostrar puntos en la línea
                            data: yData, // Aquí se grafican los valores de Y
                            emphasis: {
                                focus: 'series'
                            },
                            itemStyle: {
                                color: '#F39C12'
                            }
                        }
                    ]
                };
        
                // Establecer las opciones y renderizar la gráfica
                chart.setOption(opciones_grafica);
        
                // Esperar un breve momento antes de capturar la imagen
                setTimeout(() => {
                    const img = chart.getDataURL({
                        pixelRatio: 2,
                        backgroundColor: '#191919',
                        height: 600,
                        excludeComponents: ['dataZoom', 'toolbox']
                    });
        
                    // Remover el contenedor temporal
                    document.body.removeChild(chartContainer);
        
                    resolve(img);
                }, 500);
            });
        };
    
    const descargar = async () => {
        if (!prueba) {
            notification.error({ description: "No hay prueba cargada." });
            return;
        }
        setCargando(true);
        try {
            const tipo = prueba?.tipoPrueba;
            const instanciaPrincipal = grafica.current?.getEchartsInstance?.();
            let imgPrincipal = await capturarInstanciaEcharts(instanciaPrincipal);
            if (!imgPrincipal) {
                imgPrincipal = await capturarGraficaPdfExport(prueba, newfases, inicioFases, tipo);
            }
            if (!imgPrincipal) {
                throw new Error("No hay datos de serie para exportar la gráfica.");
            }

            const imagenesExtra = [];
            if (tipo === "CMJ" && graficasCmjVelDesp) {
                const extrasCmj = [
                    [graficasCmjVelDesp.opcVel, "Velocidad (tramo analizado)", 380],
                    [graficasCmjVelDesp.opcD, "Desplazamiento (tramo analizado)", 380],
                ];
                for (const [opcion, titulo, alto] of extrasCmj) {
                    if (!opcion) continue;
                    try {
                        const dataUrl = await capturarOpcionEcharts(opcion, "dark2", {
                            width: 1000,
                            height: alto,
                        });
                        if (dataUrl) imagenesExtra.push({ dataUrl, titulo });
                    } catch (e) {
                        console.warn(e);
                    }
                }
            }

            let parametrosPdf =
                Array.isArray(newparametros) && newparametros.length > 0
                    ? [...newparametros]
                    : [...(prueba?.parametros || [])];

            if (muestra_seleccionada) {
                parametrosPdf = parametrosPdf.map((p, i) => {
                    const refM = muestra_seleccionada?.parametros?.[i];
                    if (refM) {
                        return {
                            ...p,
                            media: refM.valor,
                            porcentaje: (Number(p.valor) / Number(refM.valor) - 1) * 100,
                            dif: Number(p.valor) - Number(refM.valor),
                        };
                    }
                    return { ...p };
                });
            }

            const tablaParametros = parametrosATablaFilas(
                parametrosPdf,
                Boolean(muestra_seleccionada)
            );
            const fasesPdf =
                Array.isArray(newfases) && newfases.length > 0 ? newfases : prueba?.fases || [];

            const creado = prueba?.prueba?.createdAt || prueba?.createdAt;
            const nombreArchivo = `Resumen_${(atletas[0]?.nombre || "atleta").replace(/[/\\?%*:|"<>]/g, "_")}_${tipo || "prueba"}_${dayjs(creado).format("DD-MM-YYYY")}_${(prueba?.momento || "").replace(/[/\\?%*:|"<>]/g, "_")}.pdf`;

            descargarResumenPdf({
                imagenPrincipalDataUrl: imgPrincipal,
                imagenesExtra,
                fases: fasesPdf,
                tablaParametros,
                atleta: atletas[0],
                prueba: prueba,
                nombreArchivo,
            });
            notification.success({ description: "PDF generado correctamente." });
        } catch (err) {
            console.error(err);
            notification.error({
                description: err?.message || err?.toString?.() || "No se pudo generar el PDF.",
            });
        } finally {
            setCargando(false);
        }
    };
    const descargarParametros = async () => {
        if (!pruebaCompleta) {
            notification.error({ description: "No hay prueba cargada." });
            return;
        }
        setCargando(true);
        try {
            const parametrosOverride =
                Array.isArray(newparametros) && newparametros.length > 0 ? newparametros : undefined;
            const blob = blobCsvParametros(pruebaCompleta, {
                muestra: muestra_seleccionada,
                repIndex,
                parametrosOverride,
            });
            if (!blob) {
                notification.error({ description: "No hay parámetros para exportar." });
                return;
            }
            const creado = pruebaCompleta?.prueba?.createdAt || pruebaCompleta?.createdAt;
            const nombreBase = `${atletas[0]?.nombre ?? "atleta"} ${pruebaCompleta?.tipoPrueba ?? "prueba"} ${dayjs(creado).format("DD-MM-YYYY")} ${pruebaCompleta?.momento ?? ""}`.trim();
            const href = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", `${nombreBase} parametros.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(href);
            notification.success({ description: "CSV de parámetros descargado." });
        } catch (err) {
            notification.error({
                description: err?.message || err?.toString?.() || "No se pudo descargar el CSV.",
            });
        } finally {
            setCargando(false);
        }
    };

    const descargarData = async () => {
            setCargando(true);
            try {
                const blob = blobCsvDatosEsp32(prueba);
                if (!blob) {
                    notification.error({
                        description: "No hay datos de la prueba para exportar.",
                    });
                    return;
                }
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute(
                    "download",
                    `${atletas[0]?.nombre} ${prueba?.tipoPrueba} ${dayjs(prueba.prueba.createdAt).format("DD-MM-YYYY")} ${prueba?.momento}.csv`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(href);
            } catch (err) {
                notification.error({
                    description: err?.message || err?.toString?.() || "No se pudo descargar el CSV.",
                });
            } finally {
                setCargando(false);
            }
        };
        
          
          
    const reCalcularParametros = async () => {
        if (!prueba?.sistema_de_pesos_y_tiempos?.length) {
            notification.error({ description: "No hay datos de la prueba para recalcular." });
            return;
        }
        const instanciaECharts = grafica.current?.getEchartsInstance();
        if (!instanciaECharts) {
            notification.error({ description: "La gráfica no está lista. Espera un momento e inténtalo de nuevo." });
            return;
        }
        setreCalculando(true);
        try {
            const opcionesGrafico = instanciaECharts.getOption();
            const dz0 = elegirOpcionDataZoom(opcionesGrafico);
            const muestras = prueba.sistema_de_pesos_y_tiempos;
            const { inicioIdx, finExclusivo, finInclusivo } = dataZoomARangoSlice(muestras, dz0);
            setInicioFases(inicioIdx);
            setFinFases(finInclusivo);

            const subset1 = muestras.slice(inicioIdx, finExclusivo);
            if (subset1.length < 8) {
                notification.error({
                    description:
                        "El tramo visible es muy corto (mínimo 8 muestras). Amplía el zoom horizontal e inténtalo de nuevo.",
                });
                return;
            }

            if (prueba.impresion === "CMJ" || prueba?.tipoPrueba === "CMJ") {
                const {
                    fases: fases_calculadas,
                    datos: datos_calculados,
                    parametros: parametros_calculados,
                } = await runCMJ(subset1);
                setParametros([...parametros_calculados]);
                setFases(fases_calculadas);
                setDatosGraficar(datos_calculados);
            } else if (prueba.impresion === "Nordic" || prueba?.tipoPrueba === "Nordic") {
                const { fases: fases_calculadas, parametros: parametros_calculados } = await runNordic(subset1);
                setParametros(parametros_calculados);
                setFases(fases_calculadas);
            } else if (prueba.impresion === "Dynamo" || prueba?.tipoPrueba === "Dynamo") {
                const { fases: fases_calculadas, parametros: parametros_calculados } = await runDynamo(subset1);
                setParametros(parametros_calculados);
                setFases(fases_calculadas);
            } else if (esCOP) {
                if (!copHistorial.length) {
                    notification.error({
                        description:
                            "Esta repetición no tiene historial COP para recalcular (se grabó con la trama antigua).",
                    });
                    return;
                }
                const muestras = prueba.sistema_de_pesos_y_tiempos ?? [];
                let tramo = copHistorial;
                if (copHistorial.length === muestras.length) {
                    tramo = copHistorial.slice(inicioIdx, finExclusivo);
                }
                if (tramo.length < 8) {
                    notification.error({
                        description:
                            "El tramo visible es muy corto (mínimo 8 muestras). Amplía el zoom horizontal e inténtalo de nuevo.",
                    });
                    return;
                }
                const { fases: fases_calculadas, parametros: parametros_calculados } = await runCOP(tramo);
                setParametros([...parametros_calculados]);
                setFases(fases_calculadas);
            }
        } catch (e) {
            console.error(e);
            notification.error({
                description: e?.message || e?.toString?.() || "Error al recalcular.",
            });
        } finally {
            setreCalculando(false);
        }
    };
    const guardarnewParametros = async () => {
            try {
                setCargando(true)
                const url = `prueba/${id}`
                const method = "patch"
                const data = {
                    // ...extra,
                    //atleta: atleta,
                    //datos_brutos: datos_brutos.current,
                    //video,
                    //sistema_de_pesos_y_tiempos,
                    fases: [ ...newfases ],
                    // Si no se recalculó, se conserva el historial guardado
                    // (en COP es el copHistorial y no debe borrarse).
                    datos: datosGraficar.length ? [ ...datosGraficar ] : prueba?.datos ?? [],
                    parametros: [ ...newparametros ],
                    inicioFases,
                    finFases,
                    //tipoPrueba: "CMJ",
                }
                await API({
                    url,
                    method,
                    data
                })
                notification.success({ description: 'Prueba editada' })
                //navigate('/pruebas')
            } catch (err) {
                notification.error({
                    description: err?.response?.data?.mensaje || err.toString()
                })
            } finally {
                setCargando(false)
                setTimeout(() => {  window.location.reload() ; }, 1200);
            }
    
        }

        let parametros = prueba?.parametros || []
        let fases = prueba?.fases || []
    
        if (muestra_seleccionada) {
    
            parametros = parametros.map((p, i) => {
                if (muestra_seleccionada?.parametros[i]) {
                    p.media = muestra_seleccionada?.parametros[i].valor
                    p.porcentaje = ((p.valor / p.media) - 1) * 100
                    p.dif = p.valor - p.media
    
                }
                return p
            })
        }
     

    return (
    <>  
        <Flex align="center" justify="space-around">
            {cargando ? <ThreeDot color="#dcc630" size="medium" text="" textColor="" /> :
            <Button type="primary" icon={<FilePdfFilled />} onClick={descargar}>Descargar Resumen[pdf]</Button>
            }
            {cargando ? <ThreeDot color="#dcc630" size="medium" text="" textColor="" /> :
            <Button type="primary" icon={<FileExcelOutlined />} onClick={descargarParametros}>Descargar Parametros[csv]</Button>
            }
            <Button type="primary" icon={<DatabaseOutlined />} onClick={descargarData}>Descargar Data Raw[csv]</Button>
                
        </Flex>
            
        
        <Typography.Title style={{ textAlign: 'center' }}>
            {prueba?.tipoPrueba || ''}
            {prueba?._repLabel && prueba?.reps?.length > 1 ? ` — ${prueba._repLabel}` : ''}
        </Typography.Title>
        <br></br>
        {prueba && !esCOP && (
            <div style={{ height: 600 }}>
                <ECharts
                    ref={grafica}
                    lazyUpdate={false}
                    theme="dark2"
                    option={
                        prueba?.tipoPrueba === "Dynamo"
                            ? opciones_graficaDynamo
                            : opciones_grafica
                    }
                    style={{ width: '100%', height: '100%' }}
                />
            </div>
        )}
        {prueba && esCOP && (
            <GraficaCOP prueba={prueba} mainChartRef={grafica} />
        )}

        {graficasCmjVelDesp ? (
            <Flex justify="center" style={{ marginTop: 12 }}>
                <Checkbox
                    checked={verVelocidadDesplazamiento}
                    onChange={(e) => setVerVelocidadDesplazamiento(e.target.checked)}
                >
                    Mostrar velocidad y desplazamiento
                </Checkbox>
            </Flex>
        ) : null}

        {graficasCmjVelDesp && verVelocidadDesplazamiento ? (
            <>
                {graficasCmjVelDesp.opcVel ? (
                    <>
                        <Typography.Title level={5} style={{ marginTop: 12, textAlign: "center" }}>
                            Velocidad (tramo analizado)
                        </Typography.Title>
                        <div style={{ height: 260 }}>
                            <ECharts
                                theme="dark2"
                                option={graficasCmjVelDesp.opcVel}
                                style={{ width: "100%", height: "100%" }}
                            />
                        </div>
                    </>
                ) : null}
                {graficasCmjVelDesp.opcD ? (
                    <>
                        <Typography.Title level={5} style={{ marginTop: 12, textAlign: "center" }}>
                            Desplazamiento (tramo analizado)
                        </Typography.Title>
                        <div style={{ height: 260 }}>
                            <ECharts
                                theme="dark2"
                                option={graficasCmjVelDesp.opcD}
                                style={{ width: "100%", height: "100%" }}
                            />
                        </div>
                    </>
                ) : null}
                {graficasCmjVelDesp.faltaDerivados ? (
                    <Typography.Text type="secondary" style={{ display: "block", marginTop: 8, textAlign: "center" }}>
                        Las gráficas de velocidad y desplazamiento aparecen al pulsar «Recalcular parámetros» o si la
                        prueba ya tiene series guardadas.
                    </Typography.Text>
                ) : null}
            </>
        ) : null}

        <Flex
            gap="middle"
            wrap="wrap"
            style={{ width: "100%", maxWidth: "100%", minWidth: 0 }}
        >
            {fasesParaMarca?.map((f, i) => (
                <Card key={i} style={{ minWidth: 140, maxWidth: 220, flex: "1 1 160px" }}>
                    <Typography.Title level={5} style={{ marginBottom: 4 }}>
                        {f.nombre}
                    </Typography.Title>
                    <Typography.Text>{(f?.tiempo?.duracion?.toFixed(2) ?? 0) * 1000} ms</Typography.Text>
                </Card>
            ))}
        </Flex>
            <br></br>
            <br></br>
            <Flex gap="middle" justify="space-around">
               
                {<SeleccionarMuestra onSeleccionar={setMuestraSeleccionada} tipe={prueba?.tipoPrueba} />}
                {
                    recalculando ? <ThreeDot color="#dcc630" size="medium" text="" textColor="" /> :
                    <Button type="primary"  onClick={reCalcularParametros}>Recalcular Parámetros</Button>
                }
                {
                    cargando ? <ThreeDot color="#dcc630" size="medium" text="" textColor="" /> :
                    <Button type="primary"  onClick={guardarnewParametros}>Guardar Parámetros</Button>
                    }
                { 
                    !esCOP && (cargando ? 
                        <ThreeDot color="#dcc630" size="medium" text="" textColor="" /> : 
                        <Button 
                        type="primary" 
                        onClick={() => navigate(`/COP/${id}`)}
                        >
                        centro de presión (COP)
                        </Button> )
                    }
                
            </Flex>
            
            <br></br>
                <TableParamsPrueba newparametros={newparametros} muestra_seleccionada={muestra_seleccionada} />
            <br></br>

    </>
    )

}